import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "autoplay"]
const _hoisted_2 = { class: "controller" }
const _hoisted_3 = { class: "icons" }
const _hoisted_4 = { class: "icon-content" }
const _hoisted_5 = { class: "volume" }
const _hoisted_6 = { class: "icon-content" }
const _hoisted_7 = {
  class: "volume-bar",
  ref: "volumeBarRef"
}
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "ptime" }
const _hoisted_10 = { class: "dtime" }
const _hoisted_11 = { class: "bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPlayOne = _resolveComponent("IconPlayOne")!
  const _component_IconPause = _resolveComponent("IconPause")!
  const _component_IconVolumeMute = _resolveComponent("IconVolumeMute")!
  const _component_IconVolumeNotice = _resolveComponent("IconVolumeNotice")!
  const _component_IconVolumeSmall = _resolveComponent("IconVolumeSmall")!

  return (_openBlock(), _createElementBlock("div", {
    class: "audio-player",
    style: _normalizeStyle({ transform: `scale(${1 / _ctx.scale})` })
  }, [
    _createElementVNode("audio", {
      class: "audio",
      ref: "audioRef",
      src: _ctx.src,
      autoplay: _ctx.autoplay,
      onDurationchange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDurationchange())),
      onTimeupdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTimeupdate())),
      onPlay: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handlePlayed())),
      onEnded: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleEnded())),
      onProgress: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleProgress())),
      onError: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleError()))
    }, null, 40, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "icon play-icon",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggle()))
        }, [
          _createElementVNode("span", _hoisted_4, [
            (_ctx.paused)
              ? (_openBlock(), _createBlock(_component_IconPlayOne, { key: 0 }))
              : (_openBlock(), _createBlock(_component_IconPause, { key: 1 }))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "icon volume-icon",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleVolume()))
          }, [
            _createElementVNode("span", _hoisted_6, [
              (_ctx.volume === 0)
                ? (_openBlock(), _createBlock(_component_IconVolumeMute, { key: 0 }))
                : (_ctx.volume === 1)
                  ? (_openBlock(), _createBlock(_component_IconVolumeNotice, { key: 1 }))
                  : (_openBlock(), _createBlock(_component_IconVolumeSmall, { key: 2 }))
            ])
          ]),
          _createElementVNode("div", {
            class: "volume-bar-wrap",
            onMousedown: _cache[8] || (_cache[8] = $event => _ctx.handleMousedownVolumeBar($event)),
            onTouchstart: _cache[9] || (_cache[9] = $event => _ctx.handleMousedownVolumeBar($event)),
            onClick: _cache[10] || (_cache[10] = $event => _ctx.handleClickVolumeBar($event))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "volume-bar-inner",
                style: _normalizeStyle({ width: _ctx.volumeBarWidth })
              }, _cache[16] || (_cache[16] = [
                _createElementVNode("span", { class: "thumb" }, null, -1)
              ]), 4)
            ], 512)
          ], 32)
        ])
      ]),
      _createElementVNode("span", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.ptime), 1),
        _cache[17] || (_cache[17] = _createTextVNode(" / ")),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.dtime), 1)
      ]),
      _createElementVNode("div", {
        class: "bar-wrap",
        ref: "playBarWrap",
        onMousedown: _cache[11] || (_cache[11] = $event => _ctx.handleMousedownPlayBar($event)),
        onTouchstart: _cache[12] || (_cache[12] = $event => _ctx.handleMousedownPlayBar($event)),
        onMousemove: _cache[13] || (_cache[13] = $event => _ctx.handleMousemovePlayBar($event)),
        onMouseenter: _cache[14] || (_cache[14] = ($event: any) => (_ctx.playBarTimeVisible = true)),
        onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.playBarTimeVisible = false))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["bar-time", { 'hidden': !_ctx.playBarTimeVisible }]),
          style: _normalizeStyle({ left: _ctx.playBarTimeLeft })
        }, _toDisplayString(_ctx.playBarTime), 7),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "loaded",
            style: _normalizeStyle({ width: _ctx.loadedBarWidth })
          }, null, 4),
          _createElementVNode("div", {
            class: "played",
            style: _normalizeStyle({ width: _ctx.playedBarWidth })
          }, _cache[18] || (_cache[18] = [
            _createElementVNode("span", { class: "thumb" }, null, -1)
          ]), 4)
        ])
      ], 544)
    ])
  ], 4))
}